export default __webpack_public_path__ + "static/media/time-and-date.6eabd24c.svg";